
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lexique",
      function () {
        return require("private-next-pages/lexique/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lexique"])
      });
    }
  